<toast-notifications>
  <div id="toast-container" class="position-fixed bottom-0 end-0 p-3" style="z-index: 1100;">
    <!-- Los toasts se añadirán dinámicamente aquí -->
  </div>

  <script>
    export default {
      // Estado global para mantener todos los toasts
      _toasts: [],
      _toastIdCounter: 0,
      _container: null,

      init() {
        // Método de inicialización que puede ser llamado desde el exterior
        this.ensureContainerExists();
        return this;
      },

      ensureContainerExists() {
        // Función para asegurar que existe el contenedor
        if (this._container) return this._container;

        // Intentar obtener el contenedor por ID
        this._container = document.getElementById('toast-container');

        // Si no existe, crearlo
        if (!this._container) {
          this._container = document.createElement('div');
          this._container.id = 'toast-container';
          this._container.className = 'position-fixed bottom-0 end-0 p-3';
          this._container.style.zIndex = '1100';
          document.body.appendChild(this._container);
        }

        return this._container;
      },

      onBeforeMount() {
        // Limpiar las referencias previas si existían
        this._toasts = [];
        this._toastIdCounter = 0;
        this._container = null;
      },

      onMounted() {
        // Asegurar que el contenedor existe
        this.ensureContainerExists();

        // Registrarse como el componente toast global
        if (typeof window !== 'undefined') {
          window._toastComponentInstance = this;
        }
      },

      onBeforeUnmount() {
        // Limpiar todos los toasts al desmontar
        this._toasts.forEach(toast => {
          if (toast.element && toast.element.parentNode) {
            toast.element.parentNode.removeChild(toast.element);
          }
        });
        this._toasts = [];
      },

      // Método para crear un nuevo toast
      show(message, type = 'primary', duration = 3000) {
        // Asegurar que el contenedor existe
        this.ensureContainerExists();

        // Asegurar que el mensaje sea seguro (evitar XSS)
        message = message.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;');

        // Crear ID único para este toast
        const toastId = this._toastIdCounter++;

        // Definir el icono según el tipo
        let icon = 'info-circle-fill';
        let title = 'Información';

        switch (type) {
          case 'success':
            icon = 'check-circle-fill';
            title = 'Éxito';
            break;
          case 'danger':
          case 'error':
            icon = 'exclamation-triangle-fill';
            title = 'Error';
            type = 'danger'; // Normalizar 'error' a 'danger'
            break;
          case 'warning':
            icon = 'exclamation-triangle-fill';
            title = 'Advertencia';
            break;
        }

        // Crear elemento toast
        const toastElement = document.createElement('div');
        toastElement.id = `toast-${toastId}`;
        toastElement.className = 'toast show mb-2';
        toastElement.setAttribute('role', 'alert');
        toastElement.setAttribute('aria-live', 'assertive');
        toastElement.setAttribute('aria-atomic', 'true');

        // Definir el contenido HTML del toast
        toastElement.innerHTML = `
          <div class="toast-header">
            <i class="bi bi-${icon} text-${type} me-2"></i>
            <strong class="me-auto">${title}</strong>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
          </div>
          <div class="toast-body">
            ${message}
          </div>
        `;

        // Añadir al contenedor
        this._container.appendChild(toastElement);

        // Añadir evento onclick al botón close
        const closeButton = toastElement.querySelector('.btn-close');
        if (closeButton) {
          closeButton.addEventListener('click', () => {
            this.hide(toastId);
          });
        }

        // Configurar auto-cierre
        const timerId = setTimeout(() => {
          this.hide(toastId);
        }, duration);

        // Almacenar referencia al toast
        this._toasts.push({
          id: toastId,
          element: toastElement,
          timerId: timerId
        });

        // Retornar el ID del toast
        return toastId;
      },

      // Método para ocultar un toast específico por ID
      hide(toastId) {
        const toastIndex = this._toasts.findIndex(t => t.id === toastId);

        if (toastIndex !== -1) {
          const toast = this._toasts[toastIndex];

          // Limpiar el temporizador si existe
          if (toast.timerId) {
            clearTimeout(toast.timerId);
          }

          // Añadir clase para animar la salida
          toast.element.classList.remove('show');
          toast.element.classList.add('fade');

          // Eliminar después de una pequeña transición
          setTimeout(() => {
            if (toast.element && toast.element.parentNode) {
              toast.element.parentNode.removeChild(toast.element);
            }

            // Eliminar del array de toasts
            this._toasts.splice(toastIndex, 1);
          }, 150);
        }
      },

      // Método para mostrar un toast de éxito
      success(message, duration = 3000) {
        return this.show(message, 'success', duration);
      },

      // Método para mostrar un toast de error
      error(message, duration = 3000) {
        return this.show(message, 'danger', duration);
      },

      // Método para mostrar un toast de advertencia
      warning(message, duration = 3000) {
        return this.show(message, 'warning', duration);
      },

      // Método para mostrar un toast informativo
      info(message, duration = 3000) {
        return this.show(message, 'info', duration);
      }
    };
  </script>

</toast-notifications>
